module.exports = __webpack_public_path__ + "img/boiler-S-idle.6de93e83.png";